/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationDto
 */
export interface OrganizationDto {
    /**
     * 
     * @type {string}
     * @memberof OrganizationDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationDto
     */
    name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationDto
     */
    updatedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationDto
     */
    isActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrganizationDto
     */
    userCount?: number;
}

/**
 * Check if a given object implements the OrganizationDto interface.
 */
export function instanceOfOrganizationDto(value: object): value is OrganizationDto {
    return true;
}

export function OrganizationDtoFromJSON(json: any): OrganizationDto {
    return OrganizationDtoFromJSONTyped(json, false);
}

export function OrganizationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'userCount': json['userCount'] == null ? undefined : json['userCount'],
    };
}

export function OrganizationDtoToJSON(json: any): OrganizationDto {
    return OrganizationDtoToJSONTyped(json, false);
}

export function OrganizationDtoToJSONTyped(value?: OrganizationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'isActive': value['isActive'],
        'userCount': value['userCount'],
    };
}

